import { z } from 'zod';

export const MedsurfTheme = z.enum([
  'dark',
  'light'
]);
export type MedsurfTheme = z.infer<typeof MedsurfTheme>;

export const MedsurfThemeStyleFileSchema = z.record(MedsurfTheme, z.string());

export const MedsurfThemeStyleFile: z.infer<typeof MedsurfThemeStyleFileSchema> = {
  [MedsurfTheme.enum.dark]: 'medsurf-dark.css',
  [MedsurfTheme.enum.light]: 'medsurf-light.css',
}

export const MedsurfThemeEditorStyleFileSchema = z.record(MedsurfTheme, z.string());

export const MedsurfThemeEditorStyleFile: z.infer<typeof MedsurfThemeEditorStyleFileSchema> = {
  [MedsurfTheme.enum.dark]: '/assets/styles/editor/ui/medsurf-dark',
  [MedsurfTheme.enum.light]: '/assets/styles/editor/ui/medsurf-light',
}

export const MainPanelDisplay = z.enum([
  'image',
  'text',
  'all'
]);
export type MainPanelDisplay = z.infer<typeof MainPanelDisplay>;

export const EditPanelDisplay = z.enum([
  'list',
  'metadata',
  'layer',
  'image',
  'annotation',
  'group',
  'poi',
  'question'
]);
export type EditPanelDisplay = z.infer<typeof EditPanelDisplay>;

export const EditPanelSelected = [
  'metadata',
  'list'
];

export const PanelDataSchema = z.object({
  isMinimized: z.boolean(),
  panelSize: z.array(z.number()),
  uncollapsedPanelSize: z.array(z.number()),
});

export type PanelData = z.infer<typeof PanelDataSchema>;

export const SidebarRatioLists = [
  {
    "value": 0,
    "name": "enum.sidebarRatio.0_no_text"
  },
  {
    "value": 3,
    "name": "enum.sidebarRatio.25"
  },
  {
    "value": 4,
    "name": "enum.sidebarRatio.33"
  },
  {
    "value": 6,
    "name": "enum.sidebarRatio.50"
  },
  {
    "value": 8,
    "name": "enum.sidebarRatio.66"
  },
  {
    "value": 9,
    "name": "enum.sidebarRatio.75"
  },
  {
    "value": 12,
    "name": "enum.sidebarRatio.100_no_image"
  },
  {
    "value": 13,
    "name": "enum.sidebarRatio.100_center_no_image"
  }
];

export const SlideStateLists = [
  {
    "name": "enum.slideState.empty",
    "value": "empty"
  },
  {
    "name": "enum.slideState.draft",
    "value": "draft"
  },
  {
    "name": "enum.slideState.in_review",
    "value": "in_review"
  },
  {
    "name": "enum.slideState.review_not_ok",
    "value": "review_not_ok"
  },
  {
    "name": "enum.slideState.final",
    "value": "final"
  }
];